import { useState } from 'react'
import { ListOption } from '../../../types/andTypes'
import { createDisplayString } from '../../../utilities/utils'
import {
  DropDownContainer,
  DropDownInput,
  DropDownList,
  DropDownText,
  DropDownItem,
  DropDownSelected,
  Label,
  HelperText,
  IconContainer
} from './dropdown-styles'

type DropDownProps = {
  icon?: JSX.Element
  listItems: ListOption[]
  listValue?: string
  setListValue: React.Dispatch<React.SetStateAction<string | undefined>>
  valueProperty?: string
  displayTemplate?: string
  displayProperty?: string
  label?: string
  helperText?: string
  isBackground?: boolean
}

const DropDown = ({
  icon,
  listItems,
  listValue,
  setListValue,
  valueProperty = 'value',
  displayTemplate,
  displayProperty = 'displayValue',
  label,
  helperText,
  isBackground = false
}: DropDownProps) => {
  const [toggleMenu, setToggleMenu] = useState(false)
  const selectedItem = listItems.find(item => item[valueProperty] === listValue)
  const displayValue = createDisplayString(selectedItem, displayProperty, displayTemplate)

  const mapItems = (item: ListOption) => {
    const itemValue = item[valueProperty] as string
    const itemDisplayValue = createDisplayString(item, displayProperty, displayTemplate)

    return (
      itemValue &&
      itemValue !== listValue && (
        <DropDownItem
          data-testid={'dropdown-item'}
          key={itemValue}
          role="listitem"
          onClick={() => {
            setListValue(itemValue)
            setToggleMenu(!toggleMenu)
          }}
        >
          <DropDownText data-testid={'dropdown-item-value'}>{itemDisplayValue}</DropDownText>
        </DropDownItem>
      )
    )
  }

  return (
    <>
      {label && <Label data-testid="dropdown-label">{label}</Label>}
      {helperText && !listValue && (
        <HelperText data-testid="dropdown-helper-text">{helperText}</HelperText>
      )}
      <DropDownContainer>
        <DropDownInput
          data-testid="dropdown-menu"
          isBackground={isBackground}
          role="button"
          onClick={() => setToggleMenu(!toggleMenu)}
        >
          <IconContainer>
            {icon && icon}
            <DropDownText data-testid="dropdown-text">{displayValue}</DropDownText>
          </IconContainer>
          {toggleMenu ? <DropDownText>&#9650;</DropDownText> : <DropDownText>&#9660;</DropDownText>}
        </DropDownInput>
        {toggleMenu && (
          <DropDownList
            data-testid="dropdown-list"
            role="list"
            onMouseLeave={() => setToggleMenu(!toggleMenu)}
          >
            <DropDownSelected>
              <DropDownText>{displayValue}</DropDownText>
            </DropDownSelected>
            {listItems.map(mapItems)}
          </DropDownList>
        )}
      </DropDownContainer>
    </>
  )
}

export default DropDown
